<template>
  <div class="register-wrapper">
    <component :is="layout" v-if="ready"></component>
  </div>
</template>

<script>
import RegisterHeNan from './Register_HeNan.vue'
export default {
  name: 'Register',
  components: {
    RegisterHeNan
  },
  data () {
    return {
      layout: '',
      ready: false
    }
  },
  mounted () {
    if (this.$route.query.mode === 'henan' || this.$route.query.mode === 'hnacs') {
      this.layout = 'RegisterHeNan'
      this.ready = true
    }
  }
}
</script>